const buildAlarmNamesMap = (): Map<number | string, string> => {
  const alarmNames = new Map<number | string, string>();
  if (!localStorage.alarmOptions) {
    return alarmNames;
  }

  const alarmOptions = JSON.parse(localStorage.alarmOptions);
  alarmOptions.forEach((object: { value: number | string; name: string }) => {
    alarmNames.set(object.value, object.name);
    alarmNames.set(String(object.value), object.name);
    const numericValue = Number(object.value);
    if (!Number.isNaN(numericValue)) {
      alarmNames.set(numericValue, object.name);
    }
  });

  return alarmNames;
};

export const getDefaultAlarmName = (
  defaultAlarmId: number | string | null | undefined
): string | undefined => {
  if (defaultAlarmId === null || defaultAlarmId === undefined) {
    return undefined;
  }

  const alarmNames = buildAlarmNamesMap();
  return (
    alarmNames.get(defaultAlarmId) ??
    alarmNames.get(String(defaultAlarmId)) ??
    (typeof defaultAlarmId === "string"
      ? alarmNames.get(Number(defaultAlarmId))
      : undefined)
  );
};
